import { UiEvent } from '../utils/ui-event';

export class ScrollTracking {
	private sentScrollPositions: Set<number> = new Set([0]);

	constructor() {
		const scrollHandler = () => {
			const scrollY: number = window.scrollY;
			const scrollHeight: number = document.body.scrollHeight - window.innerHeight;
			const scrollPercentage: number = Math.round((scrollY / scrollHeight) * 100);

			if (scrollPercentage % 10 === 0 && !this.sentScrollPositions.has(scrollPercentage)) {
				this.sentScrollPositions.add(scrollPercentage);
				UiEvent.trackUIEvent(
					'scroll',
					'scroll-tracking',
					'scroll',
					scrollPercentage.toString()
				);

				if (this.sentScrollPositions.size >= 11) {
					window.removeEventListener('scroll', scrollHandler);
				}
			}
		};

		window.addEventListener('scroll', scrollHandler, { passive: true });
	}
}
